import i18next from "i18next";
import { initReactI18next } from "react-i18next";

// Germany - Discovery+ 
import fcca_dplus_de_common from "./locales/fcca_dplus_de/common.json";
import fcca_dplus_de_form from "./locales/fcca_dplus_de/form.json";
import fcca_dplus_de_confirmation from "./locales/fcca_dplus_de/confirmation.json";
import fcca_dplus_de_interstitial_android from "./locales/fcca_dplus_de/interstitial_android.json";
import fcca_dplus_de_interstitial_ios from "./locales/fcca_dplus_de/interstitial_ios.json";
import fcca_dplus_de_footer from "./locales/fcca_dplus_de/footer.json";

import fcca_dplus_en_common from "./locales/fcca_dplus_en/common.json";
import fcca_dplus_en_form from "./locales/fcca_dplus_en/form.json";
import fcca_dplus_en_confirmation from "./locales/fcca_dplus_en/confirmation.json";
import fcca_dplus_en_interstitial_android from "./locales/fcca_dplus_en/interstitial_android.json";
import fcca_dplus_en_interstitial_ios from "./locales/fcca_dplus_en/interstitial_ios.json";
import fcca_dplus_en_footer from "./locales/fcca_dplus_en/footer.json";

// Germany - Max
import fcca_hbomax_de_common from "./locales/fcca_hbomax_de/common.json";
import fcca_hbomax_de_form from "./locales/fcca_hbomax_de/form.json";
import fcca_hbomax_de_confirmation from "./locales/fcca_hbomax_de/confirmation.json";
import fcca_hbomax_de_interstitial_android from "./locales/fcca_hbomax_de/interstitial_android.json";
import fcca_hbomax_de_interstitial_ios from "./locales/fcca_hbomax_de/interstitial_ios.json";
import fcca_hbomax_de_footer from "./locales/fcca_hbomax_de/footer.json";

import fcca_hbomax_en_common from "./locales/fcca_hbomax_en/common.json";
import fcca_hbomax_en_form from "./locales/fcca_hbomax_en/form.json";
import fcca_hbomax_en_confirmation from "./locales/fcca_hbomax_en/confirmation.json";
import fcca_hbomax_en_interstitial_android from "./locales/fcca_hbomax_en/interstitial_android.json";
import fcca_hbomax_en_interstitial_ios from "./locales/fcca_hbomax_en/interstitial_ios.json";
import fcca_hbomax_en_footer from "./locales/fcca_hbomax_en/footer.json";

// France - Discovery+
import fcc215_dplus_en_common from "./locales/fcc215_dplus_en/common.json";
import fcc215_dplus_en_form from "./locales/fcc215_dplus_en/form.json";
import fcc215_dplus_en_confirmation from "./locales/fcc215_dplus_en/confirmation.json";
import fcc215_dplus_en_interstitial_android from "./locales/fcc215_dplus_en/interstitial_android.json";
import fcc215_dplus_en_interstitial_ios from "./locales/fcc215_dplus_en/interstitial_ios.json";
import fcc215_dplus_en_footer from "./locales/fcc215_dplus_en/footer.json";

import fcc215_dplus_fr_common from "./locales/fcc215_dplus_fr/common.json";
import fcc215_dplus_fr_form from "./locales/fcc215_dplus_fr/form.json";
import fcc215_dplus_fr_confirmation from "./locales/fcc215_dplus_fr/confirmation.json";
import fcc215_dplus_fr_interstitial_android from "./locales/fcc215_dplus_fr/interstitial_android.json";
import fcc215_dplus_fr_interstitial_ios from "./locales/fcc215_dplus_fr/interstitial_ios.json";
import fcc215_dplus_fr_footer from "./locales/fcc215_dplus_fr/footer.json";

// France - Max
import fcc215_hbomax_en_common from "./locales/fcc215_hbomax_en/common.json";
import fcc215_hbomax_en_form from "./locales/fcc215_hbomax_en/form.json";
import fcc215_hbomax_en_confirmation from "./locales/fcc215_hbomax_en/confirmation.json";
import fcc215_hbomax_en_interstitial_android from "./locales/fcc215_hbomax_en/interstitial_android.json";
import fcc215_hbomax_en_interstitial_ios from "./locales/fcc215_hbomax_en/interstitial_ios.json";
import fcc215_hbomax_en_footer from "./locales/fcc215_hbomax_en/footer.json";

import fcc215_hbomax_fr_common from "./locales/fcc215_hbomax_fr/common.json";
import fcc215_hbomax_fr_form from "./locales/fcc215_hbomax_fr/form.json";
import fcc215_hbomax_fr_confirmation from "./locales/fcc215_hbomax_fr/confirmation.json";
import fcc215_hbomax_fr_interstitial_android from "./locales/fcc215_hbomax_fr/interstitial_android.json";
import fcc215_hbomax_fr_interstitial_ios from "./locales/fcc215_hbomax_fr/interstitial_ios.json";
import fcc215_hbomax_fr_footer from "./locales/fcc215_hbomax_fr/footer.json";

// Canada - Discovery+
import canada_dplus_en_common from "./locales/canada_dplus_en/common.json";
import canada_dplus_en_form from "./locales/canada_dplus_en/form.json";
import canada_dplus_en_confirmation from "./locales/canada_dplus_en/confirmation.json";
import canada_dplus_en_interstitial_android from "./locales/canada_dplus_en/interstitial_android.json";
import canada_dplus_en_interstitial_ios from "./locales/canada_dplus_en/interstitial_ios.json";
import canada_dplus_en_footer from "./locales/canada_dplus_en/footer.json";

import canada_dplus_fr_common from "./locales/canada_dplus_fr/common.json";
import canada_dplus_fr_form from "./locales/canada_dplus_fr/form.json";
import canada_dplus_fr_confirmation from "./locales/canada_dplus_fr/confirmation.json";
import canada_dplus_fr_interstitial_android from "./locales/canada_dplus_fr/interstitial_android.json";
import canada_dplus_fr_interstitial_ios from "./locales/canada_dplus_fr/interstitial_ios.json";
import canada_dplus_fr_footer from "./locales/canada_dplus_fr/footer.json";

import {
  fallbackLng,
  germany_dplus_en,
  germany_dplus_de,
  germany_hbomax_en,
  germany_hbomax_de,
  france_dplus_en,
  france_dplus_fr,
  france_hbomax_en,
  france_hbomax_fr,
  canada_dplus_en,
  canada_dplus_fr
} from "./constants/label";

const resources = {
  [germany_dplus_de]: {
    common: fcca_dplus_de_common,
    form: fcca_dplus_de_form,
    confirmation: fcca_dplus_de_confirmation,
    interstitial_android: fcca_dplus_de_interstitial_android,
    interstitial_ios: fcca_dplus_de_interstitial_ios,
    footer: fcca_dplus_de_footer
  },
  [germany_dplus_en]: {
    common: fcca_dplus_en_common,
    form: fcca_dplus_en_form,
    confirmation: fcca_dplus_en_confirmation,
    interstitial_android: fcca_dplus_en_interstitial_android,
    interstitial_ios: fcca_dplus_en_interstitial_ios,
    footer: fcca_dplus_en_footer
  },
  [germany_hbomax_de]: {
    common: fcca_hbomax_de_common,
    form: fcca_hbomax_de_form,
    confirmation: fcca_hbomax_de_confirmation,
    interstitial_android: fcca_hbomax_de_interstitial_android,
    interstitial_ios: fcca_hbomax_de_interstitial_ios,
    footer: fcca_hbomax_de_footer
  },
  [germany_hbomax_en]: {
    common: fcca_hbomax_en_common,
    form: fcca_hbomax_en_form,
    confirmation: fcca_hbomax_en_confirmation,
    interstitial_android: fcca_hbomax_en_interstitial_android,
    interstitial_ios: fcca_hbomax_en_interstitial_ios,
    footer: fcca_hbomax_en_footer
  },
  [france_dplus_en]: {
    common: fcc215_dplus_en_common,
    form: fcc215_dplus_en_form,
    confirmation: fcc215_dplus_en_confirmation,
    interstitial_android: fcc215_dplus_en_interstitial_android,
    interstitial_ios: fcc215_dplus_en_interstitial_ios,
    footer: fcc215_dplus_en_footer
  },
  [france_dplus_fr]: {
    common: fcc215_dplus_fr_common,
    form: fcc215_dplus_fr_form,
    confirmation: fcc215_dplus_fr_confirmation,
    interstitial_android: fcc215_dplus_fr_interstitial_android,
    interstitial_ios: fcc215_dplus_fr_interstitial_ios,
    footer: fcc215_dplus_fr_footer
  },
  [france_hbomax_en]: {
    common: fcc215_hbomax_en_common,
    form: fcc215_hbomax_en_form,
    confirmation: fcc215_hbomax_en_confirmation,
    interstitial_android: fcc215_hbomax_en_interstitial_android,
    interstitial_ios: fcc215_hbomax_en_interstitial_ios,
    footer: fcc215_hbomax_en_footer
  },
  [france_hbomax_fr]: {
    common: fcc215_hbomax_fr_common,
    form: fcc215_hbomax_fr_form,
    confirmation: fcc215_hbomax_fr_confirmation,
    interstitial_android: fcc215_hbomax_fr_interstitial_android,
    interstitial_ios: fcc215_hbomax_fr_interstitial_ios,
    footer: fcc215_hbomax_fr_footer
  },
  [canada_dplus_en]: {
    common: canada_dplus_en_common,
    form: canada_dplus_en_form,
    confirmation: canada_dplus_en_confirmation,
    interstitial_android: canada_dplus_en_interstitial_android,
    interstitial_ios: canada_dplus_en_interstitial_ios,
    footer: canada_dplus_en_footer
  },
  [canada_dplus_fr]: {
    common: canada_dplus_fr_common,
    form: canada_dplus_fr_form,
    confirmation: canada_dplus_fr_confirmation,
    interstitial_android: canada_dplus_fr_interstitial_android,
    interstitial_ios: canada_dplus_fr_interstitial_ios,
    footer: canada_dplus_fr_footer
  },
  [fallbackLng]: {
    common: fcca_dplus_en_common,
    form: fcca_dplus_en_form,
    confirmation: fcca_dplus_en_confirmation,
    interstitial_android: fcca_dplus_en_interstitial_android,
    interstitial_ios: fcca_dplus_en_interstitial_ios,
    footer: fcca_dplus_en_footer
  }
};

const init_i18n = i18next.use(initReactI18next);
const i18n = (userLanguage) => {
  init_i18n.init({
    react: {
      wait: true,
    },
    resources: resources,
    lng: userLanguage,
    fallbackLng: fallbackLng,
    keySeparator: ".",
    interpolation: {
      escapeValue: false,
    },
    ns: ["common", "form", "confirmation", "interstitial_android", "interstitial_ios", "footer"],
    defaultNS: "common",
    fallbackNS: ["common"],
  });

  return init_i18n;
};

export default i18n;
